import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { ButtonBase, styled, Typography } from '@mui/material'
import {
  DARSNAMEH_CONFIG,
  DESCRIPTIVE_EXAM_CONFIG,
  FORM_CONFIG,
  HOMEWORK_CONFIG,
  NEVISEH_CONFIG,
  POST_CONFIG,
} from '$common/wapp-bar-theme'
import { WappIcon } from '$comp/chat-list-tool-box/components/shared/wapp-icon'
import {
  openDarsnamehCreator,
  openDescriptiveExamCreator,
  openFormCreator,
  openHomeWorkCreator,
  openNeviseCreator,
  openPostCreator,
} from '$logic/wapps/business'

export const otherWappsConfig = [
  {
    ...POST_CONFIG,
    onClick: openPostCreator,
    logoGradient: 'linear-gradient(180deg, #909090 0%, #262626 100%)',
    key: 'POST',
  },
  {
    ...DESCRIPTIVE_EXAM_CONFIG,
    onClick: openDescriptiveExamCreator,
    logoGradient: 'linear-gradient(180deg, #FF7676 0%, #D10000 100%)',
    key: 'DESCRIPTIVE_EXAM',
  },
  {
    ...DARSNAMEH_CONFIG,
    onClick: openDarsnamehCreator,
    logoGradient: 'linear-gradient(180deg, #3444FF 0%, #0E1781 100%)',
    key: 'DARSNAMEH',
  },
  {
    ...HOMEWORK_CONFIG,
    onClick: openHomeWorkCreator,
    logoGradient: 'linear-gradient(180deg, #FF7600 0%, #E00000 100%)',
    key: 'HOMEWORK',
  },
  {
    ...NEVISEH_CONFIG,
    onClick: openNeviseCreator,
    logoGradient: 'linear-gradient(60deg, #F57073 13.4%, #FA4545 86.6%)',
    key: 'NEVISEH',
  },
  {
    ...FORM_CONFIG,
    onClick: openFormCreator,
    logoGradient: 'linear-gradient(180deg, #1DCBB0 0%, #008D77 100%)',
    key: 'FORM',
  },
]

export function OtherWapps() {
  return (
    <>
      {otherWappsConfig.map(wappConfig => (
        <ListItem
          key={wappConfig.key}
          onClick={async () => {
            await closeCurrentModal()
            wappConfig.onClick()
          }}
        >
          <WappIcon
            background={wappConfig.logoGradient}
            icon={wappConfig.icon}
          />
          <Typography variant="subtitle3" color="neutral800">
            {wappConfig.name}
          </Typography>
        </ListItem>
      ))}
    </>
  )
}

const ListItem = styled(ButtonBase)`
  height: 56px;
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  justify-content: flex-start;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral100};
  }
`
